import { useRunConversationTurnPresenter } from './useRunConversationTurnPresenter'
import { ConversationStream } from '../../views/ConversationStream'

export const RunConversationTurnPresenter = () => {
  const {
    data: { items },
    states: { isStreaming },
    commands: { selectChoice },
  } = useRunConversationTurnPresenter()

  return (
    <ConversationStream
      items={items}
      isStreaming={isStreaming}
      onChoiceSelect={selectChoice}
    />
  )
}
